import { Injectable } from "@angular/core";
import { RestServiceBase } from "@definitiv-packages/angular-dba-library";
import { RoofareaModel } from "../../../public-api";


@Injectable({
    providedIn: 'root'
})
export class RoofareaService extends RestServiceBase<RoofareaModel> {
    constructor(
    ) {
        super("RoofareaModel", false);
    }
}